
/* eslint-disable */
    import common from "@/util/common";
    import {useStore} from "@/store";
    import {defineComponent, reactive, ComputedRef, computed, toRefs} from "vue";

     interface State {
         content: string;
         icon: string;
         tit: string;
     }
export default defineComponent({
    name: 'checkDescrip',
    props: {
        renderData: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    setup(props) {
        let state: State = reactive({
            content: '',
            icon: '',
            tit: '',
        })
        const {renderData} = toRefs(props);
        function getData(code, key='value', type='') {
                return common.getDataByCode(renderData.value, code, key, type)
            }
        state.icon = getData('conclusionIcon') || '';
        state.tit = getData('conclusionResult');
        state.content = getData('conclusionDesc');
        let store = useStore()
        return {
            state,
        }
    },
    
})
